import Image from 'next/image';

import Link from '@/components/renderers/Link';
import Label from './label';

interface ContentCardProps {
  href: string;
  label: string;
  title: string;
  image: {
    src: string;
    alt?: string;
    height?: number;
    width?: number;
    blurDataURL?: string;
  };
}

export default function ContentCard({
  href,
  label,
  title,
  image,
}: ContentCardProps) {
  return (
    <Link
      href={href}
      className="flex text-haiti transition-colors hover:text-rose"
    >
      <div className="relative mr-4">
        <Image
          src={image.src}
          alt={image.alt}
          width={142}
          height={106}
          quality={100}
          {...(image.blurDataURL && {
            blurDataURL: image.blurDataURL,
            placeholder: `blur`,
          })}
          layout="fixed"
          className="max-h-[106px] max-w-[142px] rounded-lg"
        />
      </div>
      <div className="mt-2">
        <Label>{label}</Label>
        {title && (
          <span className="mt-2 block text-[15px] font-medium leading-[22px]">
            {title}
          </span>
        )}
      </div>
    </Link>
  );
}
